import { AsyncComponent } from '@r-and-a-shared-ui/core-component-config';
import { generateUniqueKey } from '@r-and-a-shared-ui/utils';
import { Article } from 'libs/common-kontent-client/src/models/MEMBERSHIP';
import styles from './ArticleList.module.scss';
import { IPagination } from '@kontent-ai/delivery-sdk';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';


type FilteredArticlesResponse = {
  queryUrl: string;
  items: Article[];
  pagination: IPagination;
};

export interface ArticleListProps {
  filteredArticles?: FilteredArticlesResponse | null;
  isLoading?: boolean;
}

export function ArticleList({
  filteredArticles,
  isLoading = false,
}: ArticleListProps) {
  const hasItems = !!filteredArticles?.items?.length;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          {isLoading && <LoadingSpinner />}

          {hasItems ? (
            filteredArticles!.items.map((article: Article) => {
              return (
                <AsyncComponent
                  key={`article-${article.system.id}-${generateUniqueKey()}`}
                  kontentItem={article}
                  contentType={'article_listicle'}
                />
              );
            })
          ) : (
            !isLoading && (
              <p className={styles['empty-list-text']}>
                No articles matching your filter criteria were found.
              </p>
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default ArticleList;
